module.exports = __webpack_public_path__ + "static/assets/b399e6544063965af2a40dba270bb5de.png";